import { BaseService } from "./base.service";

export class DocumentLogService extends BaseService {
  constructor() {
    super("/document-log");
  }

  async getAllDocumentLogs(payload: Record<string, any> = {}) {
    return this.post("/getAll", payload);
  }

  async createDocumentLog(data: Record<string, any>) {
    return this.post("", data);
  }

  async getDocumentLogById(id: string) {
    return this.get(`/${id}`);
  }

  async updateDocumentLog(id: string, data: Record<string, any>) {
    return this.patch(`/${id}`, data);
  }

  async deleteDocumentLog(id: string) {
    return this.delete(`/${id}`);
  }
}

export const documentLogService = new DocumentLogService();
